import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { CelebrationChatCreation } from './CelebrationChatCreation';
import { CelebrationPostAuthStatus } from './CelebrationPostAuthStatus';
import { CelebrationCreateEntry } from './CelebrationCreateEntry';
import { CelebrationDiscoveryChat } from './CelebrationDiscoveryChat';
import { UnifiedCelebrationForm } from './UnifiedCelebrationForm';

/**
 * Router dispatcher for /celebrations/new.
 * - mode=chat -> CelebrationChatCreation
 * - mode=quick or mode=wizard -> canonical /quick flow
 * - mode=form -> UnifiedCelebrationForm
 * - mode=post-auth-status -> CelebrationPostAuthStatus
 * - mode=choose -> CelebrationCreateEntry chooser
 * - no mode -> CelebrationDiscoveryChat (chat-first default)
 */
export const CelebrationNew: React.FC = () => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode');
  const hasType = searchParams.has('type');

  if (mode === 'post-auth-status') {
    return <CelebrationPostAuthStatus />;
  }

  if (mode === 'chat') {
    return <CelebrationChatCreation />;
  }

  if (mode === 'quick' || mode === 'wizard') {
    return <Navigate to="/quick" replace />;
  }

  if (mode === 'form' || hasType) {
    return <UnifiedCelebrationForm />;
  }

  if (mode === 'choose') {
    return <CelebrationCreateEntry />;
  }

  return <CelebrationDiscoveryChat />;
};
